import React from "react";
import Flow from "src/components/Flow";
import Dialog from "src/components/Dialog";
import { withTranslation } from "react-i18next";
import debug from "src/modules/debug-logger";
import { applyPaddleActivationToken } from "../ajax/cloud";

import steps from "./steps";
import getUserSubscription from "src/modules/auth/ajax/getUserSubscription";

function getCachedActivationData() {
  const activationData = localStorage.getItem("purchase.activationData");
  return activationData ? JSON.parse(activationData) : null;
}

class PurchaseFlow extends React.Component {
  constructor(props) {
    super(props);
    const activationData = getCachedActivationData();
    this.state = {
      error: false,
      email: activationData ? activationData.email : null,
      activationToken: activationData ? activationData.activationToken : null,
      initialStep: activationData ? "sign-up" : this.props.initialStep
    };
  }

  setFlowState = (update) => this.setState(update);
  handleRestoreFailure = () => this.setState({ error: true });
  applyPaddleActivationToken = async (activationToken) => {
    const { updateUser, app } = this.props;
    await applyPaddleActivationToken(activationToken);

    const subscription = await getUserSubscription();
    debug.purchase(
      "Applied Paddle activation token and received new subscription",
      subscription
    );
    debug.purchase("Removing activation token from localstorage");
    localStorage.removeItem("purchase.activationData");
    updateUser({ subscription });
    app.synchronizer.announceItemChange(
      app.synchronizer.SynchronizableItems.CLOUD_ACCOUNT
    );
    app.synchronizer.synchronizeCloudAccount();
  };

  render() {
    const { error, initialStep } = this.state;
    const {
      t,
      onClose,
      isMonitoring,
      stopMonitoring,
      onBack,
      freemiumInitialContent,
      updatePopoverStyle,
      setContent
    } = this.props;
    return (
      <>
        <Dialog
          isOpen={error}
          heading={t("purchase.restore.failureDialog.heading")}
          text={t("purchase.restore.failureDialog.text")}
          type="failure"
          buttons={[
            {
              onClick: onClose,
              text: t("buttons.ok")
            }
          ]}
        />
        <Flow
          steps={steps}
          onRestoreFailure={this.handleRestoreFailure}
          applyPaddleActivationToken={this.applyPaddleActivationToken}
          flowState={this.state}
          setFlowState={this.setFlowState}
          onClose={onClose}
          onBack={onBack}
          isMonitoring={isMonitoring}
          stopMonitoring={stopMonitoring}
          initialStep={initialStep}
          freemiumInitialContent={freemiumInitialContent}
          updatePopoverStyle={updatePopoverStyle}
          setContent={setContent}
        />
      </>
    );
  }
}

export default withTranslation()(PurchaseFlow);
